'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

require('./Loader.scss');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _FAIcon = require('../icon/FAIcon');

var _FAIcon2 = _interopRequireDefault(_FAIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Loader pro načítání dat. Pokud má obsah (children), je zobrazen jako načítací text, jinak se typicky použije implicitní.
 */
// --
var Loader = function (_React$Component) {
    (0, _inherits3.default)(Loader, _React$Component);

    function Loader() {
        (0, _classCallCheck3.default)(this, Loader);
        return (0, _possibleConstructorReturn3.default)(this, (Loader.__proto__ || (0, _getPrototypeOf2.default)(Loader)).apply(this, arguments));
    }

    (0, _createClass3.default)(Loader, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                noPadding = _props.noPadding,
                cardBlock = _props.cardBlock,
                className = _props.className,
                other = (0, _objectWithoutProperties3.default)(_props, ['noPadding', 'cardBlock', 'className']);


            var cls = (0, _classnames2.default)("loader", className, {
                "no-padding": noPadding,
                "card-block": cardBlock
            });
            return _react2.default.createElement(
                'div',
                (0, _extends3.default)({ className: cls }, other),
                _react2.default.createElement(_FAIcon2.default, { icon: 'circle-o-notch', animation: _FAIcon2.default.animation.spin, fixedWidth: true }),
                _react2.default.createElement(
                    'span',
                    null,
                    this.props.children || "Načítají se data"
                )
            );
        }
    }]);
    return Loader;
}(_react2.default.Component);

Loader.propTypes = {
    noPadding: _react2.default.PropTypes.bool,
    cardBlock: _react2.default.PropTypes.bool // je jako card-block
};
Loader.defaultProps = {
    noPadding: false,
    cardBlock: false
};
exports.default = Loader;
;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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